import { DaylightCommonContent } from "../DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="grid min-w-0 border border-border md:min-h-[40rem] md:grid-cols-[5fr_7fr]">
    <div className="flex min-w-0 items-end border-border p-8 md:order-1 md:border-r md:p-12 lg:p-16">
      <DaylightCommonContent
        alignment={alignment}
        buttons={buttons}
        className="min-w-0"
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingAs="h1"
        headingClassName="max-w-[14ch] text-[clamp(2.5rem,2.61vw_+_1.86rem,5rem)] leading-[0.9] tracking-[-0.04em] break-words"
      />
    </div>
    <DaylightMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="order-first h-full min-h-80 w-full border-0 md:order-2"
      imageClassName="h-full object-cover"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
